import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Etwas ist schiefgelaufen. Bitte erneut versuchen.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const UNTERLAGEN_LABELS = {
  offen: "Offen",
  fehlt: "Fehlt",
  vollstaendig: "Vollständig",
};
export const UNTERLAGEN_CLS = {
  offen: "bg-slate-100 text-slate-700 dark:bg-slate-800/60 dark:text-slate-300",
  fehlt: "bg-rose-100 text-rose-700 dark:bg-rose-900/40 dark:text-rose-300",
  vollstaendig: "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300",
};

export const STATUS_LABELS = {
  neu: "Neu",
  angemeldet: "Angemeldet",
  fertiggemeldet: "Fertiggemeldet",
  termin_vereinbart: "Zählertermin vereinbart",
  zaehler_gesetzt: "Zähler gesetzt",
  abgeschlossen: "Abgeschlossen",
};

export const ANLAGEN_TYPEN = {
  erzeugungsanlage: "Erzeugungsanlage (PV)",
  waermepumpe: "Wärmepumpe",
  stromspeicher: "Stromspeicher",
  wallbox: "Wallbox",
};

export const ANLAGEN_ART = {
  neue_anlage: "Neue Anlage",
  erweiterung: "Anlagenerweiterung",
};

export const ANREDE = {
  herr: "Herr",
  frau: "Frau",
  divers: "Divers",
  firma: "Firma",
};
